/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Info Icon component.
 */
export const InfoIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12 17V10.6208' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M12 9.47168V7.70808' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <circle cx='12' cy='12' r='10' transform='rotate(-180 12 12)' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default InfoIcon;
